import { formatCurrencyOnBlur } from '../../../helpers/utils';

export const getUpcomingProjectsExcelData = (projects: any[]) => {
  const { totalProjects, amount, hours } = projects.reduce(
    (acc, project) => ({
      totalProjects: acc.totalProjects + 1,
      amount: acc.amount + parseInt(project.amount_requested || 0, 10),
      hours: acc.hours + parseInt(project.estimated_hours || 0, 10),
    }),
    { totalProjects: 0, amount: 0, hours: 0 },
  );

  const summarySheet = [
    ['Summary'],
    ['Total Projects', totalProjects],
    ['Total Amount Requested', formatCurrencyOnBlur(amount.toString())],
    ['Total Est Hours', hours],
  ];

  const projectRows = projects.map((p) => [
    p.client?.name || p.client_name || '',
    p.funder?.name || '',
    p.program_name || '',
    p.description || '',
    formatCurrencyOnBlur(p.amount_requested),
    p.status || '',
    p.deadline || '',
    p.estimated_hours || '',
  ]);

  const projectSheet = [
    [
      'Client',
      'Funder',
      'Project Funded',
      'Description',
      'Amount Requested',
      'Status',
      'Deadline',
      'Est Hours',
    ],
    ...projectRows,
  ];

  const actionRows = [];
  projects.forEach((p) => {
    const projectLabel = p.description || p.client?.name || '';
    (p.actions || []).forEach((a) => {
      actionRows.push([
        projectLabel,
        a.title || '',
        a.type || '',
        a.assignee?.name || '',
        a.creator?.name || '',
        a.urgent ? 'Yes' : 'No',
        a.status || '',
        a.deadline || '',
      ]);
    });
  });

  const actionSheet = [
    [
      'Project',
      'Title',
      'Type',
      'Assignee',
      'Creator',
      'Urgent',
      'Status',
      'Due Date',
    ],
    ...actionRows,
  ];

  return [
    { name: 'Summary', data: summarySheet },
    { name: 'Projects', data: projectSheet },
    { name: 'Actions', data: actionSheet },
  ];
};
